<template>
	<div>
		<div>
			<div>
				<div style="text-align: center;width: 100%;">
					<div style="width: 1000px;margin: 0 auto;">
					<el-row type="flex" justify="start">
						<div v-for="item in commodityList">
							<el-card shadow="hover" style="width: 240px;background-color: #ECECEC;margin: 10px;" :body-style="{ padding: '0px', height:'308px'}">
								<div>
									<div>
										<img class="commodityImg" style="width: 240px;height: 240px;" :src="transformTo240(item.image)" onerror="this.src='http://dfs.uarm.lbslm.com/file/cloud/photo/e5799b96340449c49af2409511223e52.jpg';this.onerror=null" :title="item.price">
									</div>
									<div class="nameDiv">
										<span>
											{{item.modelName}}
										</span>
										<!-- <div style="width: 100%;text-align: right;margin-right: 10px;">
											<span style="padding-right: 15px;color: #676b72;"><span style="color: orange;">{{item.price}}</span>元</span>
										</div> -->
									</div>
								</div>
							</el-card>
						</div>
					</el-row>
					</div>
				</div>
			</div>
			<el-pagination background
		    	style="text-align:center;margin-top: 35px;margin-bottom: 55px;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[8, 16, 64, 128]"
				:page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'commodityShow',
  components: {
  },
  data() {
    return {
    	list:[],
    	commodityList:[],
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10
    }
  },
  watch: {
  },
  computed:{
  },
  mounted() {
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var thiz = this;
    	const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
	  	axios.get(this.$store.getters.getApiValue+'/application/skuList.do')
	  		.then(function (response) {
				loading.close();
				var data = response.data;
				if(data.status == "200"){
					if(data.data.length < thiz.currentPage*thiz.pageSize){
						thiz.commodityList = data.data.slice((thiz.currentPage-1)*thiz.pageSize,data.data.length);
					}else{
						thiz.commodityList = data.data.slice((thiz.currentPage-1)*thiz.pageSize,thiz.currentPage*thiz.pageSize);
					}
					console.log(thiz.commodityList);
					thiz.total = data.data.length;
				}else{
					thiz.$message.error(data.message);
				}
		}).catch(function (error) {
			loading.close();
			thiz.$message.error("系统异常，请与管理员联系!");
			console.log(error);
		});
   },
   transformTo240(img) {
	   var i=img.lastIndexOf('.');
	   return img.substring(0,i) + '_480x480.jpg';
  	}
  }
}
</script>

<style>
	.commodityDiv{
		float:left;
		width: 200px;
		margin: 10px;
	}
	.commodityImg{
		width: 240px;
		height: 240px;
	}
	.nameDiv{
		padding-top: 15px;
		padding-bottom: 15px;
		font-size: 14px;
		width: 100%;
		text-align: center;
	}
	.imageCarousel
	.el-carousel{
		width: 320px;
		height: 380px;
	}
	.imageCarousel
	.el-carousel__container{
		width: 320px;
		height: 320px;
	}
	.imageCarousel
	.el-carousel__item{
		background-color: #fff;
		height: 320px;
		line-height: 320px;
	}
	.imageCarousel
	.el-carousel__item img{
		width: 320px;
		height: 320px;
		vertical-align:middle
	}
	.messageDiv .el-main{
		padding: 0px;
	}
	.divClass{
		padding-top: 15px;
		padding-right: 50px;
	}
	.divClass span{
		line-height: 32px;
		font-size: 13px;
	}
	.saleClass{
		padding: 5px;
		margin-right: 5px;
		border: 1px solid #dcd8d8;
		background-color: white;
	}
	.hrClass{
	  	width:100%;
		margin:0 auto;
		border: 0;
		height: 1px;
		background: #fff;
		background-image: linear-gradient(to right, #adabab, #adabab, #fff);
	}
</style>
